import Vue from "vue";
import VueI18n from "vue-i18n";
import { getLanguage } from "@/utils/auth";

// language
import hkLocale from "./zh-hk"; // 繁中
import enLocale from "./en"; // 英文
import jpLocale from "./ja-jp"; // 日语
import arLocale from "./ar"; // 阿拉伯语
import frLocale from "./fr"; // 法语
import deLocale from "./de"; // 德语
import esLocale from "./es"; // 西班牙语
import itLocale from "./it"; // 意大利语
import idLocale from "./id"; // 印尼语
import thLocale from "./th"; // 泰语
import trLocale from "./tr"; // 土耳其
import viLocale from "./vi"; // 越南
import koLocale from "./ko"; // 韩语
import adlLocale from "./adl"; // 奥地利
import bdLocale from "./bd"; // 冰岛
import bjlyLocale from "./bjly"; // 保加利亚
import blLocale from "./bl"; // 波兰
import dmLocale from "./dm"; // 丹麦
import flLocale from "./fl"; // 芬兰
import jkLocale from "./jk"; // 捷克
import kldyLocale from "./kldy"; // 克罗地亚
import lmnyLocale from "./lmny"; // 罗马尼亚
import lsbLocale from "./lsb"; // 卢森堡
import nlLocale from "./nl"; // 荷兰
import nwLocale from "./nw"; // 挪威
import ptLocale from "./pt"; // 葡萄牙
import rdLocale from "./rd"; // 瑞典
import rsLocale from "./rs"; // 瑞士
import sewyLocale from "./sewy"; // 塞尔维亚
import slwnyLocale from "./slwny"; // 斯洛文尼亚
import wklLocale from "./wkl"; // 乌克兰
import xlLocale from "./xl"; // 希腊
import xylLocale from "./xyl"; // 匈牙利
// import hiLocale from './hi' // 印地语
// import ruLocale from './ru' // 俄语
// import cnLocale from './zh-CN'//简中
Vue.use(VueI18n);

const messages = {
  "zh-hk": { ...hkLocale },
  en: { ...enLocale },
  "ja-jp": { ...jpLocale },
  ar: { ...arLocale },
  fr: { ...frLocale },
  de: { ...deLocale },
  es: { ...esLocale },
  it: { ...itLocale },
  id: { ...idLocale },
  th: { ...thLocale },
  tr: { ...trLocale },
  vi: { ...viLocale },
  ko: { ...koLocale },
  adl: { ...adlLocale },
  bd: { ...bdLocale },
  bjly: { ...bjlyLocale },
  bl: { ...blLocale },
  dm: { ...dmLocale },
  fl: { ...flLocale },
  jk: { ...jkLocale },
  kldy: { ...kldyLocale },
  lmny: { ...lmnyLocale },
  lsb: { ...lsbLocale },
  nl: { ...nlLocale },
  nw: { ...nwLocale },
  pt: { ...ptLocale },
  rd: { ...rdLocale },
  rs: { ...rsLocale },
  slwny: { ...slwnyLocale },
  sewy: { ...sewyLocale },
  wkl: { ...wklLocale },
  xl: { ...xlLocale },
  xyl: { ...xylLocale },
  // 'hi': { ...hiLocale },

  // 'ru': { ...ruLocale },
  // 'zh-CN': { ...cnLocale },
};

function getLang() {
  const defaultLanguage = window.global.defaultLanguage;
  const chooseLanguage = getLanguage();
  if (chooseLanguage) return chooseLanguage;
  // if has not choose language
  return defaultLanguage;
}

const i18n = new VueI18n({
  // set locale
  locale: getLang(),
  // set locale messages
  messages,
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js